'use strict';

import toggleArray from '../util/toggle-array';

const compLib = {
	init: function () {
		//this.retrieve();
		this.initDropdown();
		this.initDropdownOption();
		this.initCheckbox();
		this.initSearchBox();
		this.initEverythingElseListener();
		this.initMobileToolSheet();
	},
	state: {},
	initDropdown: function () {
		var dropdowns = document.querySelectorAll('.cl-dropdown');
		for (var ddIndex = 0; ddIndex < dropdowns.length; ++ddIndex) {

			var controlId = dropdowns[ddIndex].id;
			if (!Object.prototype.hasOwnProperty.call(compLib.state, controlId)) compLib.state[controlId] = [];
			dropdowns[ddIndex].onclick = this.toggleDropDown;
			dropdowns[ddIndex].selectedValues = compLib.state[controlId];
			dropdowns[ddIndex].allValues = {};
			var checkboxes = dropdowns[ddIndex].querySelectorAll('input[type=\'checkbox\']');
			for (var cbIndex = 0; cbIndex < checkboxes.length; ++cbIndex) {
				var checkbox = checkboxes[cbIndex];
				dropdowns[ddIndex].allValues[checkbox.name] = checkbox.getAttribute('data-raw-title');
			}
		}
	},
	closeAllMenus: function () {
		var dropdowns = document.querySelectorAll('.cl-dropdown-container');
		for (var ddIndex = 0; ddIndex < dropdowns.length; ++ddIndex) {
			dropdowns[ddIndex].classList.add('cl-hide');
		}
		var dropdownparents = document.querySelectorAll('.cl-dropdown-title');
		for (var ddpIndex = 0; ddpIndex < dropdownparents.length; ++ddpIndex) {
			dropdownparents[ddpIndex].classList.remove('active');
		}
	},
	toggleDropDown: function (event) {
		event.stopPropagation();

		// get my reference and status
		const target = event.target.closest('.cl-dropdown');
		const isClosed = target.querySelector('.cl-dropdown-container').classList.contains('cl-hide');

		// get other's references & close them if open
		compLib.closeAllMenus();

		// if my status was closed, change my status to open
		if (isClosed) {
			target.querySelector('.cl-dropdown-container').classList.remove('cl-hide');
			target.classList.add('active');
		}

		// in mobile mode this menu acts differently. No need to pay attention to other menus and close them, just simply toggle this one regardless of the others.
		target.classList.toggle('cl-toggle');

	},
	initDropdownOption: function () {
		var checkboxes = document.querySelectorAll('.a-checkbox');
		for (var cbIndex = 0; cbIndex < checkboxes.length; ++cbIndex) {
			var parentControl = checkboxes[cbIndex].closest('.cl-dropdown');
			var cb = checkboxes[cbIndex].querySelector('input[type=\'checkbox\']');
			if(parentControl){
				if (parentControl.selectedValues.includes(cb.name)) {
					cb.setAttribute('checked', true)
				}
				checkboxes[cbIndex].onchange = this.toggleDropdownOption;
				compLib.renderDropDown(checkboxes[cbIndex], parentControl.selectedValues);
			}
		}
	},
	toggleDropdownOption: function (event) {
		event.stopPropagation()

		const target = event.target.closest('.a-checkbox');

		const checkbox = target.querySelector('input[type=\'checkbox\']');
		const parentDropdown = event.target.closest('.cl-dropdown');
		var selectedValues = parentDropdown ? parentDropdown.selectedValues : [];
		selectedValues = toggleArray(selectedValues, checkbox.name);

		compLib.state[parentDropdown.id] = selectedValues
		compLib.renderDropDown(target, selectedValues);
		compLib.persist();

		if (typeof parentDropdown.onChangeHandler === 'function') {
			parentDropdown.onChangeHandler(selectedValues);
		}
	},
	renderDropDown(target, values) {
		const parentDropdown = target.closest('.cl-dropdown')
		const ddTitle = parentDropdown.querySelector('.cl-dd-title');

		var ddSelectedItemsCount = values.length;
		var ddSelectedItemsList = values.map(id => parentDropdown.allValues[id]).join(', ')
		ddTitle.querySelector('.cl-dd-count').innerText = ddSelectedItemsCount ? ('(' + ddSelectedItemsCount + ')') : '';
		ddTitle.querySelector('.cl-dd-list').innerText = ddSelectedItemsCount ? (': ' + ddSelectedItemsList) : '';
	},
	checkboxes: {},
	initCheckbox: function () {
		const controls = document.querySelectorAll('.cl-checkbox-group');

		for (var cbgIndex = 0; cbgIndex < controls.length; ++cbgIndex) {

			var controlId = controls[cbgIndex].id;
			if (!Object.prototype.hasOwnProperty.call(compLib.state, controlId)) compLib.state[controlId] = [];

			controls[cbgIndex].values = compLib.state[controlId];

			const checkboxes = controls[cbgIndex].querySelectorAll('.cl-checkbox');
			for (var cbIndex = 0; cbIndex < checkboxes.length; ++cbIndex) {
				checkboxes[cbIndex].checked = compLib.state[controlId].includes(checkboxes[cbIndex].name); // set the persisted or default status
				checkboxes[cbIndex].onclick = this.toggleCheckbox;
			}
		}
	},
	toggleCheckbox: function (event) {
		event.stopPropagation();
		const cb = event.target;
		const parentControl = event.target.closest('.cl-checkbox-group');
		var values = parentControl.values;
		values = toggleArray(values, cb.name);
		compLib.state[parentControl.id] = values;
		compLib.persist();

		if (typeof parentControl.onChangeHandler === 'function') {
			parentControl.onChangeHandler(values);
		}
	},
	initEverythingElseListener: function () {
		document.addEventListener('click', event => {
			// am I decendent of a .cl-dropdown-bar
			const parentControl = event.target.closest('.cl-dropdown-bar');
			if (!parentControl || !parentControl.length) {
				// I am not. We're done here.
				compLib.closeAllMenus();
			}
		});
	},
	initSearchBox: function () {
		const controls = document.querySelectorAll('.cl-searchbox .search-box input[type="text"]');
		for (var sbIndex = 0; sbIndex < controls.length; ++sbIndex) {
			if (!Object.prototype.hasOwnProperty.call(compLib.state, controls[sbIndex].id)) compLib.state[controls[sbIndex].id] = '';
			else controls[sbIndex].value = compLib.state[controls[sbIndex].id];
			controls[sbIndex].oninput = this.queueInput
		}
	},
	pendingInputCall: -1,
	pendingInputElement: null,
	queueInput: function (event) {
		compLib.pendingInputElement = event.target;
		if (compLib.pendingInputCall > -1) clearTimeout(compLib.pendingInputCall);
		compLib.pendingInputCall = setTimeout(compLib.fireInput, 1000);
	},
	fireInput: function () {
		compLib.state[compLib.pendingInputElement.id] = compLib.pendingInputElement.value;
		compLib.persist();
		compLib.pendingInputElement.onChangeHandler(compLib.pendingInputElement.value)
	},
	initMobileToolSheet: function () {
		const controls = document.querySelectorAll('.cl-mobile-tool-sheet-toggle');
		for (var mtsIndex = 0; mtsIndex < controls.length; ++mtsIndex) {
			controls[mtsIndex].onclick = this.toggleMobileToolSheet
		}
	},
	toggleMobileToolSheet: function (event) {
		const parentControl = event.target.closest('.cl-mobile-tool-sheet-toggle');
		const targetId = parentControl.getAttribute('data-target-id');
		var target;
		if (parentControl && targetId) {
			target = document.getElementById(targetId);
		} else {
			target = event.target.closest('.cl-toolsheet');
		}
		if (target) target.classList.toggle('open');
	},
	// controller states will be persisted in session
	persist: function () {
		sessionStorage.setItem(compLib.dataKey, JSON.stringify(compLib.state));
	},
	// controller states will be persisted in session
	retrieve: function () {
		let state = JSON.parse(sessionStorage.getItem(compLib.dataKey));
		if (state) compLib.state = state;
	},
	dataKey: 'compLib/state/' + window.location.href.split('?')[0],
	mergeState: function (externalState) {
		for (let [key, val] of Object.entries(externalState)) {
			compLib.state[key] = val;

		}
		//console.log('mergeState', compLib.state)
		this.init();
	},
}

export default compLib;
